import { motion } from "framer-motion";
import { LineReveal } from "./Reveal";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView();
};

const callouts = ["3 év garancia", "Részletfizetés", "Stúdió minőség"];

export const Hero = () => {
  return (
    <section id="hero" className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="eyebrow text-[var(--terra)] mb-6"
            data-testid="hero-eyebrow"
          >
            Prémium pilates reformerek · közvetlenül a gyártósorról
          </motion.p>
          <LineReveal
            lines={["High-end", "reformerek", "megfizethető áron."]}
            className="font-serif-d font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
          />
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            className="mt-7 text-base md:text-lg text-[var(--ink-soft)] max-w-lg leading-relaxed"
            data-testid="hero-subheadline"
          >
            A legnagyobb gyártó gépei – brandjegyek nélkül. Ugyanaz a stúdió-szintű
            mérnöki minőség, amit a világ vezető pilates stúdióiban talál, prémium
            árképzés nélkül.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.85 }}
            className="mt-9 flex flex-wrap gap-4"
          >
            <button
              data-testid="hero-calculator-btn"
              onClick={() => scrollTo("kalkulator")}
              className="btn-terra rounded-full px-7 py-3.5 text-sm font-semibold"
            >
              Személyre szabott árkalkuláció →
            </button>
            <button
              data-testid="hero-references-btn"
              onClick={() => scrollTo("referenciak")}
              className="rounded-full px-7 py-3.5 text-sm font-semibold border border-[var(--ink)] hover:bg-[var(--ink)] hover:text-white transition-colors"
            >
              Stúdióreferenciák
            </button>
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.05 }}
            className="mt-12 grid grid-cols-3 gap-4 border-t border-[var(--line)] pt-7"
          >
            {callouts.map((c) => (
              <p key={c} className="eyebrow text-[var(--ink-muted)] leading-relaxed">
                {c}
              </p>
            ))}
          </motion.div>
        </div>
        <div className="lg:col-span-6 relative">
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="absolute -inset-3 border border-[var(--terra)]/40 rounded-t-[172px]" />
            <div className="relative overflow-hidden rounded-t-[160px] bg-[var(--stone-bg2)]">
              <img
                src="/hero.jpg"
                alt="Pilates Factory reformer stúdió"
                data-testid="hero-image"
                className="w-full h-[420px] lg:h-[560px] object-cover object-[50%_68%]"
              />
            </div>
            <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-md rounded-2xl px-5 py-4 shadow-xl">
              <p className="eyebrow text-[var(--ink-muted)]">Alapár már</p>
              <p className="font-serif-d font-semibold text-2xl">395 000 Ft-tól</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
